
export default {
  typesOfBusiness: [
    { id: 1, name: 'Unlocker / Reseller' },
    { id: 2, name: 'Store Owner' },
    { id: 3, name: 'Wholesaler / Phone Flipper / Buying and Selling Phones' },
    { id: 4, name: 'Just looking to unlock "1" phone' },
  ]
};
